import { isNull } from "lodash";

import {
  ASK_QUESTION,
  BUY_OR_SELL,
  SCHEDULE_SHOWING
} from "../constants/formTypes";

const getInitialFormValues = ({
  building,
  contactFormType,
  currentUser = {},
  expert,
  listing
} = {}) => {
  const formValues = {};
  let formBody = "I am interested in";

  if (contactFormType) {
    // eslint-disable-next-line default-case
    switch (contactFormType) {
      case ASK_QUESTION: {
        formBody = "I have a question regarding";
        break;
      }
      case SCHEDULE_SHOWING: {
        formBody = "I’m interested in scheduling a showing for";
        break;
      }
      case BUY_OR_SELL:
        formValues.buy_sell = "buy";
        break;
    }
  }

  return {
    ...Object.keys(currentUser).reduce(
      (memo, key) => ({
        ...memo,
        [key]: isNull(currentUser[key]) ? "" : currentUser[key]
      }),
      {}
    ),
    ...formValues,
    body: `${formBody} ${
      listing
        ? `${listing.address.pretty_address} ${listing.address.unit}`
        : building?.address.pretty_address
    }.`,
    building_id: building?.id,
    contact_id: expert?.contact.id,
    contact_name: expert?.contact.name,
    expert,
    listing_id: listing?.id,
    subject: building?.address.pretty_address
  };
};

export default getInitialFormValues;
